import { array, boolean, mixed, number, object, string } from "yup";

export enum VatRateCode {
  VAT_23 = "23",
  VAT_12 = "12",
  VAT_8 = "8",
  VAT_5 = "5",
  VAT_0 = "0",
  EU_REVERSE_CHARGE = "EU_REVERSE_CHARGE",
  ZW = "ZW",
  NP = "NP",
}

export enum VatExplanationCode {
  VAT_PL_23 = "VAT_PL_23",
  VAT_EU_NO_VAT_23 = "VAT_EU_NO_VAT_23",
  VAT_EU_REVERSE_CHARGE = "VAT_EU_REVERSE_CHARGE",
  VAT_EU_NP_VIES_INVALID = "VAT_EU_NP_VIES_INVALID",
  VAT_NON_EU_NP = "VAT_NON_EU_NP",
  VAT_DEFAULT = "VAT_DEFAULT",
}

export interface SubscriptionPlanPreviewPosition {
  productId: number | null;
  name: string;
  quantity: number;
  unitNetAmount: number;
  unitNetAmountAfterDiscount: number;
  unitGrossAmount: number;
  totalNet: number;
  totalGross: number;
  totalVat: number;
  vatRateCode: VatRateCode;
  discountType: string | null;
  discountValue: number | null;
}

export interface SubscriptionPlanPreviewSummary {
  currency?: string;
  totalNet: number;
  totalVat: number;
  totalGross: number;
}

export interface SubscriptionPlanPreviewResource {
  vatRateCode: VatRateCode;
  vatExplanationCode: VatExplanationCode;
  buyerCountry: string | null;
  viesVerified: boolean | null;
  positions: SubscriptionPlanPreviewPosition[];
  summary: SubscriptionPlanPreviewSummary;
}

const subscriptionPlanPreviewPositionSchema = object({
  productId: number().integer().nullable().default(null),
  vatRateCode: mixed<VatRateCode>()
    .oneOf(Object.values(VatRateCode) as VatRateCode[])
    .required(),
  name: string().required(),
  quantity: number().integer().required(),
  unitNetAmount: number().integer().required(),
  unitNetAmountAfterDiscount: number().integer().required(),
  unitGrossAmount: number().integer().required(),
  totalNet: number().integer().required(),
  totalGross: number().integer().required(),
  totalVat: number().integer().required(),
  discountType: string().nullable().default(null),
  discountValue: number().nullable().default(null),
});

const subscriptionPlanPreviewSummarySchema = object({
  currency: string().optional(),
  totalNet: number().integer().required(),
  totalVat: number().integer().required(),
  totalGross: number().integer().required(),
});

export const subscriptionPlanPreviewResourceSchema = object({
  vatRateCode: mixed<VatRateCode>()
    .oneOf(Object.values(VatRateCode) as VatRateCode[])
    .required(),
  vatExplanationCode: mixed<VatExplanationCode>()
    .oneOf(Object.values(VatExplanationCode) as VatExplanationCode[])
    .required(),
  buyerCountry: string().nullable().default(null),
  viesVerified: boolean().nullable().default(null),
  positions: array().of(subscriptionPlanPreviewPositionSchema).required(),
  summary: subscriptionPlanPreviewSummarySchema.required(),
});
